module.exports = __webpack_public_path__ + "img/yt.df1be377.svg";